(function () {
  'use strict';

  const input = document.querySelector('[data-predictive-search-input]');
  const resultsEl = document.querySelector('[data-predictive-search-results]');
  if (!input || !resultsEl) return;

  let controller;

  function renderResults(data) {
    const products = data.resources.results.products || [];
    const showPrice = resultsEl.dataset.showPrice === 'true';
    const showVendor = resultsEl.dataset.showVendor === 'true';
    if (!products.length) {
      resultsEl.innerHTML = `<p class="predictive-search__empty">${window.themeStrings?.searchNoResults || 'No results found'}</p>`;
      return;
    }
    resultsEl.innerHTML = products
      .map((product) => {
        const image = product.featured_image ? product.featured_image.url : '';
        const price = showPrice && product.price ? `<span class="predictive-search__price">${product.price}</span>` : '';
        const vendor = showVendor && product.vendor ? `<span class="predictive-search__vendor">${product.vendor}</span>` : '';
        return `
          <a href="${product.url}" class="predictive-search__result">
            ${image ? `<img src="${image}" alt="" width="60" height="75" loading="lazy">` : ''}
            <span class="predictive-search__result-info">
              ${vendor}
              <span class="predictive-search__result-title">${product.title}</span>
              ${price}
            </span>
          </a>`;
      })
      .join('');
  }

  const search = EveryRise.debounce(function (value) {
    if (!value) {
      resultsEl.innerHTML = '';
      return;
    }
    if (controller) controller.abort();
    controller = new AbortController();
    fetch(`/search/suggest.json?q=${encodeURIComponent(value)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor`, {
      signal: controller.signal,
    })
      .then((res) => res.json())
      .then(renderResults)
      .catch(() => {});
  }, 250);

  input.addEventListener('input', (e) => search(e.target.value.trim()));
})();
